
// -> {
// 	reversed: { // list of parents branch
// 		event1: [p1, p2, p3],
// 		event2: [p4, p5, p6],
// 	},
// 	straight: {
// 		event1: [p1, p2, p3],
// 		event2: [p4, p5, p6],
// 	},
// }
const prepareHierarchy = hierarchy => {

	const straight = {}
	const reversed = {}

	if(hierarchy){
		level({hierarchy, straight, reversed});
	}

	normalize({straight, reversed});

	return {straight, reversed};
}

export default prepareHierarchy;

export const normalize = ({straight, reversed}) => {
	Object.entries(straight).forEach(([eventName, dependencies]) => {
		straight[eventName] = dependencies.sort();
	});
	Object.entries(reversed).forEach(([eventName, dependencies]) => {
		reversed[eventName] = dependencies.sort();
	});
	return {straight, reversed};
}

const level = ({hierarchy, straight, reversed, parents = []}) => {

	Object.entries(hierarchy).forEach(([eventName, childHierarchy]) => {

		straight[eventName] = straight[eventName] || [];
		reversed[eventName] = reversed[eventName] || [];
		const reversedForEvent = reversed[eventName];
		
		parents.forEach(parentEvent => {
			if(parentEvent == eventName){
				return;
			}
			straight[parentEvent].push(eventName);
			if(!reversedForEvent.includes(parentEvent)){
				reversedForEvent.push(parentEvent);
			}
		});

		level({
			hierarchy: childHierarchy, 
			straight,
			reversed,
			parents: [...parents, eventName],
		});
	});
}